import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, offerDetails }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-2xl w-full max-w-md">
        <div className="p-6 md:p-8">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-destructive/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={32} className="text-destructive" />
          </div>

          <h2 className="text-xl md:text-2xl font-semibold text-foreground text-center mb-3">
            Delete Offer?
          </h2>

          <p className="text-sm md:text-base text-muted-foreground text-center mb-6">
            Are you sure you want to delete the offer from <span className="font-semibold text-foreground">{offerDetails?.buyerName}</span>? This action cannot be undone.
          </p>

          {offerDetails && (
            <div className="bg-muted rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Offer Price:</span>
                <span className="font-semibold text-foreground data-text">
                  ${offerDetails?.offerPrice?.toLocaleString()}
                </span>
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="ghost"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Delete Offer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;